import { render, staticRenderFns } from "./case_json.vue?vue&type=template&id=25202a94&"
import script from "./case_json.vue?vue&type=script&lang=js&"
export * from "./case_json.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports